import { IDashboardDto } from "../dto";
import { Api, getCompanyId } from "../helpers";
import { IDashboardDataRequest } from "../models";

export class DashboardApi {
  static async getDashboard(
    body: IDashboardDataRequest,
  ): Promise<IDashboardDto | undefined> {
    const companyId = getCompanyId();

    if (!companyId) {
      return undefined;
    }

    const requestUrl = `/api/v1/core/c/${companyId}/dashboard/dashboard_data`;
    const response = await Api.post<IDashboardDto | undefined>(
      requestUrl,
      body,
    );
    return response?.data;
  }
}
